<script lang="ts" setup></script>

<template>
  <div class="frame">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.frame {
  border: 1px solid var(--default-disabled-button-bg-color);
  border-radius: 8px;
  padding: rem-calc(24px) rem-calc(20px);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
}
</style>
